import React from 'react'

import { useCanary } from '@bill/canary.react'

import MaintenanceScreen from './MaintenanceScreen'

export const Root = ({ children }: React.PropsWithChildren) => {
  const maintMode = useCanary('sputnik-maint-mode')

  if (maintMode) return <MaintenanceScreen />

  return (
    <div
      data-testid='root'
      id='main-content'
    >
      {children}
    </div>
  )
}
